module.exports = __webpack_public_path__ + "img/amio.36063db8.svg";